<template>
	
	<div class="content-area__inner no-padding no-scroll-y">
		
		<ContentAreaTitle
			ref="titleBar"
			:icon="$store.getters.project.logo_url"
			:title="$store.getters.project.name"
			:subtitle="$store.getters.project.description ? $store.getters.project.description : 'N/A'"
			:tabs="$router.options.routes[2].children[1].children">
			<template slot="image">
				<ImageUploader style="float: left; margin-right: 10px;" :small="true" :url="$store.getters.project.logo_url" :project="$store.getters.project.id"/>
			</template>
		</ContentAreaTitle>
		
		<router-view :style="{
			'display': 'block',
			'position': 'absolute',
			'height': 'auto',
			'margin-top': `${titleBarHeight}px`,
			'top': 0,
			'right': 0,
			'left': 0,
			'bottom': 0
		}" key="project"></router-view>
		
	</div>
	
</template>

<script>
	
	import ImageUploader from "@/components/ImageUploader";
	
	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "Project",
		
		components: { ImageUploader, ContentAreaTitle },
		
		data() {
			return {
				titleBarHeight: 0,
			}
		},
		
		mounted() {
			
			// Update title bar height.
			
			this.titleBarHeight = this.$refs.titleBar.$el.clientHeight;
			
			// Refresh project data.
			
			this.$store.dispatch("refreshSelectedProject", { slug: this.$route.params.projectSlug });
			
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/Project.vue